type DetailSummaryProps = {
    text: string;
};
/**
 * Display story summary
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the DetailSummary component
 */
export default function DetailSummary({ text }: DetailSummaryProps) {
    return (
        <div className="detailSummary" data-testid="detailSummary">
            {text}
        </div>
    );
}
